import React from 'react';
import { SINGULAR_EVENTS } from '../constants/singularEventTypes';
import {
  isSingularEventEnabled,
  trackContentClick,
} from '../utils/singularUtils';

/**
 * Fires a single `content_click` Singular event per content instantiated in
 * the player. Meant to be called once, at the shared point where the player
 * gets a `content` to play, so every entry point (banner, carousel, EPG...)
 * is covered without instrumenting each widget's click handler individually.
 * @param {object} content content passed to <Player />
 * @param {Record<string, boolean>|undefined} eventsConfig client's useSingular.events
 * @param {Record<string, unknown>} [extra]
 */
export function useSingularContentClick(content, eventsConfig, extra = {}) {
  const lastTrackedIdRef = React.useRef(null);

  React.useEffect(() => {
    if (!content?.id || content.id === lastTrackedIdRef.current) {
      return;
    }

    if (!isSingularEventEnabled(SINGULAR_EVENTS.CONTENT_CLICK, eventsConfig)) {
      return;
    }

    lastTrackedIdRef.current = content.id;
    trackContentClick(content, extra);
  }, [content?.id, eventsConfig]);
}
